export default __webpack_public_path__ + "9045f20dedb8d037ecee569231906f60.png";